import React, { memo, useEffect, useState, useRef, useCallback } from 'react';
import { createUseStyles, Button, useTheme } from 'hoi-poi-ui';
import ContentLoader from 'react-content-loader';
import { useWeb5Context } from "../../lib/Web5Context";
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'ContractsValidation');
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "40",
  rx: "3",
  ry: "3",
  width: 200,
  height: "8"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "70",
  rx: "3",
  ry: "3",
  width: 120,
  height: "8"
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "120",
  rx: "3",
  ry: "3",
  width: 900,
  height: "900"
});
const ContractsValidation = /*#__PURE__*/memo(_ref => {
  let {
    contracts,
    sendAcceptance,
    logOut,
    completeLogin
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const theme = useTheme();
  const [finalContract, setFinalContract] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const finalContracts = useRef([]);
  const onConfirm = useCallback(() => {
    setIsLoading(true);
    sendAcceptance && sendAcceptance({
      idAgreement: finalContract === null || finalContract === void 0 ? void 0 : finalContract.id,
      accepted: true
    }).then(() => {
      var _finalContracts$curre, _finalContracts$curre2;
      (_finalContracts$curre = finalContracts.current) === null || _finalContracts$curre === void 0 ? void 0 : _finalContracts$curre.shift();
      if ((_finalContracts$curre2 = finalContracts.current) !== null && _finalContracts$curre2 !== void 0 && _finalContracts$curre2.length) {
        setFinalContract(finalContracts.current[0]);
        setIsLoading(false);
      } else {
        return completeLogin();
      }
    }).catch(err => {
      setIsLoading(false);
      console.error(err);
    });
  }, [finalContract === null || finalContract === void 0 ? void 0 : finalContract.id, sendAcceptance, completeLogin]);
  const onCancel = useCallback(() => {
    if (finalContract !== null && finalContract !== void 0 && finalContract.needAccept) return logOut && logOut();else {
      var _finalContracts$curre3, _finalContracts$curre4;
      (_finalContracts$curre3 = finalContracts.current) === null || _finalContracts$curre3 === void 0 ? void 0 : _finalContracts$curre3.shift();
      sendAcceptance && sendAcceptance({
        idAgreement: finalContract === null || finalContract === void 0 ? void 0 : finalContract.id,
        accepted: false
      });
      if ((_finalContracts$curre4 = finalContracts.current) !== null && _finalContracts$curre4 !== void 0 && _finalContracts$curre4.length) {
        setFinalContract(finalContracts.current[0]);
        setIsLoading(false);
      } else {
        return completeLogin();
      }
    }
  }, [finalContract === null || finalContract === void 0 ? void 0 : finalContract.id, finalContract === null || finalContract === void 0 ? void 0 : finalContract.needAccept, logOut, sendAcceptance, completeLogin]);
  useEffect(() => {
    if (contracts !== null && contracts !== void 0 && contracts.length && !finalContracts.current.length) {
      finalContracts.current = contracts;
      setFinalContract(contracts[0]);
      setIsLoading(false);
    }
  }, [contracts, finalContract, setFinalContract]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.iframeContainer
  }, (!contracts || isLoading) && /*#__PURE__*/React.createElement(ContentLoader, {
    height: 900,
    width: 900,
    speed: 2,
    backgroundColor: theme.colors.grey[50],
    foregroundColor: theme.colors.grey[100]
  }, _ref2, _ref3, _ref4), (finalContract === null || finalContract === void 0 ? void 0 : finalContract.agreementUrl) && !isLoading && /*#__PURE__*/React.createElement("iframe", {
    className: classes.iframe,
    title: "contract",
    src: finalContract === null || finalContract === void 0 ? void 0 : finalContract.agreementUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonsContainer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onCancel,
    className: classes.button,
    type: "terciary"
  }, t('action_cancel')), /*#__PURE__*/React.createElement(Button, {
    onClick: onConfirm,
    isLoading: isLoading
  }, t('action_accept'))));
});
export default ContractsValidation;